import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { calculateWidthFromId } from 'utils/widget-helpers';

import layoutStyles from '../utils/dashboard-layouts.styles';

import { findWidgetForGridSlot } from '../dashboard-layouts.utils';

const useStyles = makeStyles({
  ...layoutStyles
});

const DynamicLayout = ({ id, widgets, availableSlots, dateState, ...rest }) => {
  const classes = useStyles();
  const remainingItems = [...Array(availableSlots).keys()];
  const calculateWidgetForSlot = useCallback(
    slot => findWidgetForGridSlot({ id, widgets, availableSlots, slot, dateState, ...rest }),
    [availableSlots, id, rest, widgets]
  );

  return (
    <Grid container direction="row" justify="flex-start" alignItems="stretch" spacing={1}>
      {remainingItems &&
        remainingItems.map(item => (
          <Grid
            key={`widget-grid-key-${item}`}
            item
            xs={12}
            md={calculateWidthFromId(id)}
            className={classes.chartStyle}
          >
            {calculateWidgetForSlot(item)}
          </Grid>
        ))}
    </Grid>
  );
};

DynamicLayout.propTypes = {
  id: PropTypes.number.isRequired,
  widgets: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      colSpan: PropTypes.number.isRequired,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      dateRangeType: PropTypes.string,
      dateMatchType: PropTypes.number.isRequired,
      isChartTooltipDisplayed: PropTypes.bool.isRequired,
      isTitleDisplayed: PropTypes.bool.isRequired,
      isDateDisplayed: PropTypes.bool.isRequired,
      isLegendDisplayed: PropTypes.bool.isRequired,
      id: PropTypes.string.isRequired,
      dateRangeTypeId: PropTypes.number.isRequired,
      masterObjectId: PropTypes.number.isRequired,
      masterObjectTypeId: PropTypes.number,
      overlay: PropTypes.shape({
        baseWidget: PropTypes.shape({
          name: PropTypes.string.isRequired,
          widgetType: PropTypes.shape({
            name: PropTypes.string.isRequired
          }).isRequired
        }).isRequired
      }).isRequired
    }).isRequired
  ).isRequired,
  availableSlots: PropTypes.number.isRequired
};

export default DynamicLayout;
